import { FieldSkeleton } from 'components/secondaryMarket/shared';
import { BlockSkeleton } from 'components/secondaryMarket/shared/Blocks/BlockSkeleton';
import { VerticalFormGroupSkeleton } from 'components/shared/FormGroup';
import { FC } from 'react';

export const SecondaryBookingInformationSkeleton: FC = () => {
  return (
    <BlockSkeleton id="booking-information" labelSize={20}>
      <div>
        <div className="row">
          <VerticalFormGroupSkeleton labelSize={15} className="col-md-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
          <VerticalFormGroupSkeleton labelSize={15} className="col-md-6">
            <FieldSkeleton />
          </VerticalFormGroupSkeleton>
        </div>
      </div>
    </BlockSkeleton>
  );
};

SecondaryBookingInformationSkeleton.displayName = 'LiveBookingInformationSkeleton';
